import React from 'react';
import ContentLoader, { ContentLoaderProps } from 'react-content-loader';

interface MenuLoaderProps extends ContentLoaderProps {
  viewBox?: string;
}

export const InstaStories = (props: MenuLoaderProps) => {
  return (
    <ContentLoader viewBox="0 0 400 475" height={200} width={100} {...props}>
      <circle cx="15" cy="30" r="13" />

      <rect x="35" y="25" rx="4" ry="4" width="60" height="5" />
      <rect x="0" y="50" rx="5" ry="5" width="100" height="470" />
    </ContentLoader>
  );
};
